import { Component, OnDestroy, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { Kundenbetreuer } from '../../domain/model/kundenbetreuer';
import { KundenbetreuerService } from '../../service/kundenbetreuer/kundenbetreuer.service';
import { MatTableDataSource } from '@angular/material/table';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { SettingsKundenbetreuerDetailComponent } from '../settings-kundenbetreuer-detail/settings-kundenbetreuer-detail.component';
import { take, takeWhile } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'tnb-settings-kundenbetreuer',
    templateUrl: './settings-kundenbetreuer-page.component.html',
    styleUrls: [
        './settings-kundenbetreuer-page.component.scss',
    ],
    standalone: false,
})
export class SettingsKundenbetreuerPageComponent implements OnInit, OnDestroy {
    private westnetzSidenavService = inject(WestnetzSidenavService);
    private kundenbetreuerService = inject(KundenbetreuerService);
    private router = inject(Router);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public componentDestroyed = false;

    public columnsToDisplay = [
        'nachname',
        'vorname',
    ];

    public kundenbetreuerList: MatTableDataSource<Kundenbetreuer> = new MatTableDataSource<Kundenbetreuer>();

    ngOnInit() {
        this.reloadKundenbetreuer();
        this.westnetzSidenavService.closeRightnav$
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(() => {
                this.reloadKundenbetreuer();
            });
    }

    private reloadKundenbetreuer() {
        this.kundenbetreuerService.getAllKundenbetreuer()
            .pipe(take(1))
            .subscribe(kb => {
                this.kundenbetreuerList.data = kb;
                this.changeDetectorRef.markForCheck();
            });
    }

    public createKundenbetreuer() {
        this.router.navigate([],
            {
                queryParams: { kundenbetreuer: '' },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsKundenbetreuerDetailComponent);
    }

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }

    openKundenbetreuer(kundenbetreuer: Kundenbetreuer) {
        this.router.navigate([],
            {
                queryParams: { kundenbetreuer: kundenbetreuer.id },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsKundenbetreuerDetailComponent);

    }
}
